/**
 * Job tag + band color. Service cards use the tech color; non-WO jobs (contract / overhead / warranty)
 * share one flow and differ only by this tag and band color.
 * Used by the dispatch board, the tech's mobile cards/pills and the map pins.
 */
export const CONTRACT_COLOR = "#3B82F6";

export const JOB_KINDS = {
  contract: { tag: "CON", label: "Contract Job", color: CONTRACT_COLOR, tagCls: "bg-blue-600 text-white", textCls: "text-blue-600" },
  overhead: { tag: "OH", label: "Service Overhead", color: "#F59E0B", tagCls: "bg-[#F59E0B] text-slate-900", textCls: "text-amber-600" },
  warranty: { tag: "WAR", label: "Warranty / Closed Job", color: "#D946EF", tagCls: "bg-[#D946EF] text-white", textCls: "text-fuchsia-600" },
};
export const NON_WO_KINDS = Object.keys(JOB_KINDS);
export const kindMeta = (k) => JOB_KINDS[k] || JOB_KINDS.contract;

// "isContract" = any non-WO job (lives in contract_jobs); kind tells which.
export const isContract = (d) => !!d?.contract_job_id || NON_WO_KINDS.includes(d?.job_kind);
export const jobKindOf = (d) => (isContract(d) ? (JOB_KINDS[d?.job_kind] ? d.job_kind : "contract") : "service");
// Band = tech color for service stops, job-kind color for contract/OH/warranty.
export const bandColor = (d, tech) => (isContract(d) ? kindMeta(jobKindOf(d)).color : tech?.color || d?.tech_color || "#64748b");

export function JobTag({ d, kind, size = "xs", className = "", testId }) {
  const k = kind || jobKindOf(d);
  const meta = JOB_KINDS[k];
  const sz = size === "sm" ? "text-[8px] px-1 h-[12px]" : "text-[6px] px-[3px] h-[9px]";
  return (
    <span
      className={`inline-flex items-center rounded-sm font-black tracking-wide leading-none shrink-0 ${sz} ${meta ? meta.tagCls : "bg-slate-800 text-white"} ${className}`}
      data-testid={testId || `job-tag-${k}`}
      data-kind={k}
      title={meta ? meta.label : "Service"}
    >
      {meta ? meta.tag : "SER"}
    </span>
  );
}

export function JobBand({ d, tech, className = "" }) {
  return <div className={`absolute left-0 top-0 bottom-0 w-1 rounded-l ${className}`} style={{ backgroundColor: bandColor(d, tech) }} data-testid={`job-band-${jobKindOf(d)}`} />;
}
